
import { IconName } from "@/data/types";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "SvgIcon",

  props: {
    icon: {
      type: String as PropType<IconName>,
      required: true,
    },
    size: {
      default: 2,
      type: Number,
    },
  },

  computed: {
    href() {
      return `${require("../assets/svg/symbols.svg")}#${this.icon}`;
    },
  },
});
